<template>
    <v-container>
        <v-row class="tw-m-0 tw-p-0 mx-auto tw-max-w-5xl tw-py-3">
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-container fluid class="tw-space-y-6 tw-pb-6">
                    <v-row>
                        <v-col cols="12" md="3" class="pt-5">
                            <FormDescription>
                                <template #title>
                                    {{ $t('admin.app.detail_integration.title') }}
                                </template>
                                <template #copy>
                                    {{ $t('admin.app.detail_integration.description') }}
                                </template>
                            </FormDescription>
                        </v-col>
                        <v-col cols="12" md="9">
                            <v-card class="tw-rounded-3xl tw-shadow-md tw-p-6 tw-mb-4 tw-space-y-4">
                                <v-text-field
                                    v-model="integration.name"
                                    :label="$t('admin.app.name_integration')"
                                    outlined
                                    rounded
                                    hide-details
                                />
                                <v-text-field
                                    v-model="integration.token_url"
                                    label="Token Url"
                                    outlined
                                    rounded
                                    hide-details
                                />
                                <v-text-field
                                    v-model="integration.data_url"
                                    label="Data Url"
                                    outlined
                                    rounded
                                    hide-details
                                />
                                <v-text-field
                                    v-model="integration.client_id"
                                    label="Client Id"
                                    outlined
                                    rounded
                                    hide-details
                                />
                                <v-text-field
                                    v-model="integration.client_secret"
                                    label="Client Secret"
                                    outlined
                                    rounded
                                    hide-details
                                />
                                <v-text-field
                                    v-model="integration.token_ttl"
                                    label="Client Secret"
                                    outlined
                                    rounded
                                    hide-details
                                />
                                <div class="tw-flex tw-flex-col tw-justify-end lg:tw-ml-2">
                                    <v-checkbox v-model="integration.active" hide-details>
                                        <template #label>
                                            Habilita el uso de esta integración
                                        </template>
                                    </v-checkbox>
                                    <v-checkbox v-model="integration.use_for_register" hide-details>
                                        <template #label>
                                            Habilita el uso desde register
                                        </template>
                                    </v-checkbox>
                                    <v-checkbox v-model="integration.needs_proxy" hide-details>
                                        <template #label>
                                            Habilita el uso de proxy
                                        </template>
                                    </v-checkbox>
                                </div>
                            </v-card>
                            <div class="tw-flex tw-items-center tw-justify-end tw-mb-4">
                                <AppBtn icon="key" color="white" class="tw-shadow-md" @click="addMapping">
                                    {{ $t('admin.app.add_key') }}
                                </AppBtn>
                            </div>
                            <v-card class="tw-rounded-3xl tw-shadow-md tw-p-6">
                                <template v-if="integration.mapping && integration.mapping.length > 0">
                                    <v-simple-table>
                                        <template #default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">
                                                        {{ $t('admin.app.camps.key') }}
                                                    </th>
                                                    <th class="text-left">
                                                        {{ $t('admin.app.camps.value') }}
                                                    </th>
                                                    <th class="text-left">
                                                        {{ $t('admin.app.camps.action') }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(field, index) in integration.mapping" :key="index">
                                                    <td>
                                                        <v-text-field 
                                                            v-model="field.key" type="text" placeholder="key"
                                                            color="primary darken-1" solo single-line dense flat
                                                            hide-details />
                                                    </td>
                                                    <td>
                                                        <v-select
                                                            v-model="field.value"
                                                            :items="availableFormFields"
                                                            item-text="label"
                                                            item-value="name"
                                                            placeholder="Selecciona un campo"
                                                            dense
                                                            solo
                                                            flat
                                                            hide-details
                                                            clearable
                                                        />
                                                    </td>
                                                    <td>
                                                        <button 
                                                            type="button" class="tw-text-red-500"
                                                            @click="removeMapping(index)">{{ $t('app.delete') }}</button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </template>
                                <template v-else>
                                    <EmptyState>
                                        {{ $t('$vuetify.noDataText') }}
                                    </EmptyState>
                                </template>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import FormDescription from '@/components/FormDescription.vue'
import AppBtn from '@/components/App/AppBtn.vue'
import EmptyState from '@/components/EmptyState.vue'
import { mapState } from 'vuex'
export default {
    name: 'IntegrationFormBase',
    components: {
        FormDescription,
        AppBtn,
        EmptyState,
    },
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        ...mapState({
            registry: (state) => state.registries.show.data,
        }),
        rootFormFields() {
            return [
                { label: 'First Name', name: 'first_name' },
                { label: 'Last Name', name: 'last_name' },
                { label: 'Email', name: 'email' },
            ]
        },
        activeForm() {
            return this.registry.forms.find(f => f.language_id === this.registry.language_id)
                || {}
        },
        availableFormFields() {
            const defs = (this.activeForm.default_fields || [])
                .filter(f => f.is_active)
                .map(f => ({ label: f.label, name: f.name }))

            const customs = (this.activeForm.fields || [])
                .filter(f => f.is_active)
                .map(f => ({ label: f.label, name: f.name }))

            return [...this.rootFormFields, ...defs, ...customs]
        },
        integration: {
            get() {
                return this.value
            },
            set(newValue) {
                this.$emit('input', newValue)
            },
        },
    },
    methods: {
        addMapping() {
            this.integration.mapping.push({ key: '', value: '' })
        },
        removeMapping(index) {
            this.integration.mapping.splice(index, 1)
        },
        submitUpdate() {
            this.$store.dispatch('integrations/update', {
                payload: {
                    ...this.integration,
                    registry_id: this.registry.id,
                },
            })
            .catch((error) => {
                console.error(error)
            })
        },
        submitCreate() {
            this.$store.dispatch('integrations/store', {
                payload: {
                    ...this.integration,
                    registry_id: this.registry.id,
                },
            })
            .then(() => {
                this.$router.push({ name: 'admin.registries.integrations.index' })
            })
            .catch((error) => {
                console.error(error)
            })
        },
    },
}
</script>